
import Vue from 'vue'
export default Vue.extend({
  scrollToTop: true,
  data() {
    return {
      content: {},
    }
  },
  async created() {
    this.content = await this.$content()
      .only(['title', 'updatedAt', 'slug'])
      .fetch()
  },
  methods: {
    isEmpty(param: Object): boolean {
      return Object.keys(param).length === 0
    },
  },
})
